module.exports = __webpack_public_path__ + "img/home_content_01@2x.1d273975.png";